import fetchWithRefresh from './fetchWithRefresh';
import { UPDATE_PT_ID_IN_APPOINTMENT } from './constants';

export default async (aid: string, oid?: string): Promise<void> => {
    return fetchWithRefresh(UPDATE_PT_ID_IN_APPOINTMENT(aid), {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'PUT',
        body: JSON.stringify({
            payload: { oid },
        }),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not update appointment');
        }
    });
};
